import React from 'react';
import type { FC } from 'react';

interface EditDocumentIconProps {
    className?: string;
}

export const EditDocumentIcon: FC<EditDocumentIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Edit Document Icon</title>
            <path
                d="M16.6465 4.64642L15.3536 3.35353C15.1583 3.15827 14.8417 3.15827 14.6465 3.35353L9.08348 8.91653C9.0286 8.97142 8.98724 9.03833 8.9627 9.11197L8 12L10.888 11.0373C10.9617 11.0128 11.0286 10.9714 11.0835 10.9165L16.6465 5.35353C16.8417 5.15827 16.8417 4.84169 16.6465 4.64642Z"
                stroke="white"
                strokeLinejoin="round"
            />
            <path d="M15 7L13 5" stroke="white" />
            <path d="M11 11L8.99999 9" stroke="white" />
            <path
                d="M15 11V15C15 15.5523 14.5523 16 14 16H5C4.44772 16 4 15.5523 4 15V6C4 5.44772 4.44772 5 5 5H9"
                stroke="white"
            />
        </svg>
    );
};
